import {observer} from "mobx-react";
import IconApply from "../../../../../components/icons/icon-apply/icon-apply";
import IconDiscard from "../../../../../components/icons/icon-discard/icon-discard";
import {ButtonIcon} from "../../../../../components/inputs/button-icon/button-icon";
import {Textarea, TEXTAREA_VARIANTS} from "../../../../../components/inputs/textarea/textarea";
import RoundLoader, {RoundLoaderType} from "../../../../../components/loaders/round-loader/round-loader";
import RmaPageStore from "../../stores/rma-page-store";

interface INewTimelineItemProps {
    rmaMainStore: RmaPageStore;
    
}
const NewTimelineItem : React.FC<INewTimelineItemProps> = observer(({rmaMainStore})=> {
    return (
        <>
            <div className={'timeline-message-icon'}>
                { rmaMainStore.isSavingNewNote
                    ? <RoundLoader type={RoundLoaderType.Dark}/>
                    : <>
                        <ButtonIcon Component={IconApply} disabled={rmaMainStore.newTimelineNote.length === 0} onClick={rmaMainStore.addNote}/>
                        <ButtonIcon Component={IconDiscard} onClick={rmaMainStore.discardNewTimelineNote}/>
                      </>
                }
            </div>
            <Textarea variant={TEXTAREA_VARIANTS.DEFAULT} value={rmaMainStore.newTimelineNote} onChange={(v => rmaMainStore.setNewTimelineNote(v))}/>
        </>
    )
});

export default NewTimelineItem;